import React, { useState } from 'react';

import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';

import { CustomInputInterface } from '@utils';

export const CustomInput: React.FC<CustomInputInterface> = ({
	label = '',
	placeHolder,
	labelClassName = '',
	type = 'text',
	value,
	inputClassName = '',
	required = false,
	error,
	containerStyle,
	onChange,
	maxLength,
	icon,
}) => {
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const inputType = type === 'password' && isPasswordVisible ? 'text' : type;

	return (
		<div className={`flex  flex-col ${containerStyle}`}>
			{label && (
				<label className={`content mb-2 ${labelClassName}`}>{label}</label>
			)}
			<div className="relative ">
				<input
					maxLength={maxLength}
					type={inputType}
					value={value}
					required={required}
					placeholder={placeHolder}
					onChange={(e) => onChange && onChange(e)}
					className={`h-10 p-4 content rounded border  border-light-black w-full ${
						icon || type === 'password' ? 'pr-10' : ''
					} ${inputClassName}`}
				/>

				{type === 'password' && (
					<span
						className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
						onClick={() => setIsPasswordVisible(!isPasswordVisible)}
					>
						{isPasswordVisible ? (
							<RiEyeOffLine className="h-5 w-5" />
						) : (
							<RiEyeLine className="h-5 w-5" />
						)}
					</span>
				)}
				{icon && type !== 'password' && (
					<span className="absolute right-3 top-1/2 transform -translate-y-1/2">
						{icon}
					</span>
				)}
			</div>
			{error && <span className="text-light-red text-xs mt-1">{error}</span>}
		</div>
	);
};
